// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bhg_ji","CommentListPlaceholder--Legacy":"ih_b bhg_ra bhg_wo"};